export enum PractitionerStatus {
  Any = 'Any',
  Approved = 'Approved',
  ApprovedConditionally = 'Approved with Conditions',
  PendingApproval = 'Pending Approval',
  Rejected = 'Rejected'
}
